const technicians =
{
    title  : 'Technicien',
    titleX : 'Techniciens'
};

export default technicians ;
